<template>
  <div>
    <Validate v-if="dmr === null"></Validate>
    <div v-else>
      <v-container fluid>
        <v-layout row>
          <v-flex sm6 style="margin-right:10px">
            <div>
              <v-toolbar dense>
                <v-toolbar-title>Beneficiary List</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items></v-toolbar-items>
              </v-toolbar>
              <v-card v-for="(item,i) in benifylist" :key="i" style="margin-top:5px">
                <v-card-title style="padding-bottom:0px;">
                  <div>
                    <div>Name: {{ item.name }}</div>
                    <div>Bank: {{ item.bank }}</div>
                    <div>Acc No: {{item.account }}</div>
                    <div>IFSC Code: {{ item.ifsc }}</div>
                  </div>
                </v-card-title>
                <v-card-actions>
                  <v-btn flat color="success" @click="currentb = item; transfer = true;">Transfer</v-btn>
                  <v-btn flat color="info" @click="validate(item)">Validate</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat color="error" @click="remove(item)">remove</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-flex>
          <v-flex sm6 style="margin-left:10px">
            <v-toolbar dense>
              <v-toolbar-title>Add Beneficiary</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items></v-toolbar-items>
            </v-toolbar>
            <div>
              <!-- <v-text-field
                type="text"
                style="width:300px;margin:0 auto;height:60px;margin-top:20px"
                label="Beneficiary Name"
                v-model="bname"
                solo
              />-->
              <v-text-field
                type="number"
                style="width:300px;margin:0 auto;height:60px;display:none"
                label="Beneficiary Mobile"
                v-model="bmobile"
                solo
              />
              <v-text-field
                type="number"
                style="width:300px;margin:0 auto;height:60px;margin-top:20px"
                label="Beneficiary Account Number"
                v-model="baccount"
                solo
              />
              <v-autocomplete
                style="width:300px;margin:0 auto;height:60px;"
                :items="banklist"
                item-text="bank_name"
                label="Bank Name"
                v-model="bank"
                return-object
                solo
              />
              <v-text-field
                type="text"
                style="width:300px;margin:0 auto;height:60px;"
                label="IFSC Code"
                v-model="bifsccode"
                solo
              />
              <v-text-field
                type="text"
                style="width:300px;margin:0 auto;height:60px;"
                label="Beneficiary Name"
                v-model="bbname"
                solo
              />
              <v-text-field
                type="text"
                style="width:300px;margin:0 auto;height:60px;display:none"
                label="Branch Name"
                v-model="bbranch"
                solo
              />
              <div style="width:300px;margin:0 auto;height:60px;">
                <v-btn
                  color="primary"
                  @click="addbeneficiary"
                  style="width:300px;margin-left:0px;"
                >Add Beneficiary</v-btn>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-dialog v-model="transfer" persistent width="400">
      <v-card>
        <v-card-title>Transfer Money</v-card-title>
        <v-divider></v-divider>
        <v-card-title style="padding-bottom:0px;">
          <div style="margin-bottom:10px;">
            <div>Name: {{ currentb.name }}</div>
            <div>Bank: {{ currentb.bank }}</div>
            <div>Acc No: {{currentb.account }}</div>
            <div>IFSC Code: {{ currentb.ifsc }}</div>
          </div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex sm6>
            <v-radio-group style="margin-left:20px;" row v-model="type">
              <v-radio label="IMPS" value="IMPS"></v-radio>
              <v-radio label="NEFT" value="NEFT"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              type="number"
              style="height:60px;width:180px;"
              label="Amount"
              v-model="amount"
              solo
            />
          </v-flex>
        </v-layout>
        <v-card-title>
          <div>
            <div style="color:red">{{ dmrmessage }}</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="success" :disabled="loader"  v-if="dmrmessage !== ''" @click="submit">Confirm and pay</v-btn>
          <v-btn flat color="info" v-else @click="dmrcharge">Transfer</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="error"
            @click="transfer = false; amount = '';dmrmessage =''; currentb = {}"
          >Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="otpcheck" persistent width="300" height="300">
      <v-card>
        <v-card-title>Enter OTP</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            type="number"
            style="width:200px;margin:0 auto;height:60px;"
            label="OTP"
            v-model="otp"
            solo
          />
          <v-btn color="primary" @click="verifyotp" style="width:200px;margin-left:35px">Submit</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Loader v-if="loader"></Loader>
  </div>
</template>
<script>
import Loader from "../components/Loader.vue";
import Validate from "./Validate";
export default {
  data() {
    return {
      loader: false,
      transfer: false,
      otpcheck: false,
      type: "IMPS",
      otp: "",
      benifylist: [],
      banklist: [],
      bname: "",
      bank: {},
      bmobile: "",
      baccount: "",
      bifsccode: "",
      bbname: "",
      bbranch: "",
      currentb: {},
      amount: "",
      dmrmessage: "",
      bid: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    security() {
      return this.$store.getters.security;
    },
    dmr() {
      return this.$store.getters.instapay;
    }
  },
  watch: {
    dmr(val) {
      if (val != null) {
        this.fetchbenify();
        this.fetchbank();
      }
    },
    bank(val) {
      console.log(val);
      this.bifsccode = val.branch_ifsc;
    },
    amount() {
      this.dmrmessage = "";
    }
  },
  methods: {
    async submit() {
      let vm = this;
      if (vm.amount === "") return vm.notification("warn", "Amount Required");
      if (vm.user == null || !vm.user.phone)
        return vm.notification("error", "Login Required!");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_MobileNo: vm.dmr.mobile_no,
        Beneficiary_Id: vm.currentb.id,
        Amount: vm.amount,
        IMPS_NEFT: vm.type,
        Account_No: vm.currentb.account,
        IFSC: vm.currentb.ifsc,
        Security_Key: vm.security,
        Sender_Name: vm.dmr.name,
        Bank_Name: vm.currentb.bank
      };
      vm.loader = true;
      let list = vm.transList();
      let error = false;
      let totalamount = vm.amount;
      let total = 0;
      let message = "";
      for (var i = 0; i < list.length; i++) {
        try {
          doc.Amount = list[i];
          if (!error) {
            message += `Transfer amount : ${list[i]} </br>`;
            let res = await vm.sendMoney(doc);
            message += `Response : ${res}</br> </br>`;
            total += Number(list[i]);
          }
        } catch (e) {
          error = true;
          message += `Response : ${e} </br></br>`;
        }
      }
      message += `Total amount : ${totalamount} </br>`;
      message += `Transfered amount : ${total} </br>`;
      vm.loader = false;
      vm.amount = "";
      vm.dmrmessage = "";
      vm.transfer = false;
      vm.$root.alert(message);
    },
    sendMoney(doc) {
      const vm = this;
      return new Promise((resolve, reject) => {
        vm.$store
          .dispatch("axiosdmrpost", {
            url: "Money_Transfer",
            type: "instapay",
            data: doc
          })
          .then(function(res) {
            if (res.data.statuscode === "True") {
              resolve(res.data.status);
              //            return vm.$root.alert(res.data.status);
            }
            reject(res.data.status);
            //          return vm.$root.alert(res.data.status);
          })
          .catch(function(error) {
            reject(error.message);
            //          vm.$root.alert(error.message);
            reject(error);
          });
      });
    },
    transList() {
      const vm = this;
      let list = [];
      let total = vm.amount;
      let limit = 5000;
      let closing = vm.balance;
      let doc = {
        MobileNo: vm.user.phone,
        PinNo: vm.user.pin,
        Amount: limit
      };
      if (total > limit) {
        let reminder = total % limit;
        let subtotal = total - reminder;
        let count = subtotal / limit;
        for (var i = 0; i < count; i++) {
          list.push(limit);
        }
        if (reminder !== 0) {
          list.push(reminder);
        }
      } else {
        list.push(total);
      }
      return list;
    },
    dmrcharge() {
      let vm = this;
      if (vm.amount === "") return vm.notification("warn", "Amount Required");
      if (Number(vm.amount) > 25000)
        return vm.notification("warn", "Amount can't be more then 25000");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Amount: vm.amount,
        Source: "json"
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiospost", {
          url: "DMTF_Charge",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          vm.dmrmessage = res.data.Message;
        })
        .catch(function(error) {
          vm.loader = false;
          vm.notification("error", error);
        });
    },
    addbeneficiary() {
      let vm = this;
      if (vm.bname === "")
        if (vm.baccount === "")
          //        return vm.notification("warn", "Beneficiary Name Required");
          //    if(vm.bmobile === "") return vm.notification("warn","Beneficiary Mobile Required")
          //    if(vm.bmobile.length !== 10) return vm.notification("warn","Enter Valid Mobile");
          return vm.notification("warn", "Beneficiary Account Required");
      if (vm.bifsccode === "")
        return vm.notification("warn", "Beneficiary IFSC Code Required");
      if (vm.bbname === "")
        return vm.notification("warn", "Beneficiary Name Required");
      //    if(vm.bbranch === "") return vm.notification("warn","Beneficiary Branch Required")
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_Id: vm.dmr.id,
        Name: vm.bbname,
        Register_MobileNo: vm.dmr.mobile_no,
        AccountNo: vm.baccount,
        IFSC: vm.bifsccode,
        Security_Key: vm.security
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Add_Beneficiary",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.fetchbenify();
          vm.loader = false;
          let data = res.data;
          vm.bname = "";
          vm.bank = {};
          vm.bmobile = "";
          vm.baccount = "";
          vm.bifsccode = "";
          vm.bbname = "";
          vm.bbranch = "";
          if (data.statuscode === "True") {
            vm.notification("success", "Beneficiary added");
            return;
          }
          vm.notification("error", data.status);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    verifyotp() {
      let vm = this;
      if (vm.otp === "") return vm.notification("warn", " OTP Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_Id: vm.dmr.id,
        Beneficiary_Id: vm.bid,
        Security_Key: vm.security,
        OTP: vm.otp
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Beneficiary_Delete_Validate_OTP",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.statuscode === "ERR") {
            vm.notification("error", data.status);
            return;
          }
          vm.otpcheck = false;
          vm.notification("success", data.status);
          vm.otp = "";
          vm.fetchbenify();
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    fetchbenify() {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        source: "json",
        Sender_MobileNo: vm.dmr.mobile_no,
        Security_Key: vm.security
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "CheckUser",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data.data.beneficiary;
          vm.benifylist = data;
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    fetchbank() {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        source: "json",
        Security_Key: vm.security
      };
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "GetBank_List",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          console.log(res);
          vm.banklist = res.data.data;
        })
        .catch(function(err) {
          vm.notification("error", err.message);
        });
    },
    remove(item) {
      let vm = this;
      vm.currentb = item;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Sender_Id: vm.dmr.id,
        Beneficiary_Id: item.id,
        Security_Key: vm.security
      };
      let check = confirm("Are you sure?");
      if (!check) return;
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Beneficiary_Delete",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.statuscode === "True") {
            if (data.data.otp === 1) {
              vm.otpcheck = true;
              vm.bid = item.id;
              vm.notification("success", data.status);
              return;
            } else {
              vm.fetchbenify();
              vm.notification("success", data.status);
              return;
            }
          }
          vm.notification("error", data.status);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    validate(item) {
      let vm = this;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        source: "json",
        Sender_Name: vm.dmr.name,
        Bank_Name: item.bank,
        Sender_MobileNo: vm.dmr.mobile_no,
        IFSC: item.ifsc,
        Account_No: item.account,
        Security_Key: vm.security
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Verify_Beneficiary",
          type: "instapay",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.statuscode === "False") {
            vm.$root.alert(data.status);
            return;
          }
          vm.$root.alert(data.status);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.$root.alert(data.status);
        });
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    }
  },
  mounted() {
    this.fetchbank();
  },
  components: { Loader, Validate }
};
</script>